import React from 'react';
import { Text } from '@fluentui/react/lib/Text';
import { Icon, IconButton, IContextualMenuProps, IIconProps, ComboBox, IComboBoxOption } from '@fluentui/react';
import TimeTaxSupportSystemClient from '../../../system';
import MessageCourier from '../../../lib/MessageCourier';
import { ProjectStatus } from '../../Common/ProjectStatus';
import { Collaborator } from '../../../system/collaborators/Collaborator';
import ProjectConfigurationForm from './ProjectConfigurationForm';
import InputField from '../../../lib/FormValidator/Form/InputField';
import CustomInputIfc from '../../../lib/FormValidator/Form/CustomInputIfc';
import { InputFieldForStartEnd } from '../../../lib/FormValidator/Form/InputFieldForStartEnd';
import ToggleInput from '../../../lib/FormValidator/Form/ToggleInput';
import TextArea from '../../../lib/FormValidator/Form/TextAreaField';
import { ConfirmPreloadTeam } from './ConfirmPreloadTeam';
import CollaboratorTeam from '../../../system/collaborators/collaborator_team/CollaboratorTeam';
import { OrganizationChartNode } from '../../../system/organization_chart/OrganizationChartNode';
import { OrganizationChartDropdown } from '../../Common/OrganizationChartDropdown';
import { t } from 'i18next';
import { useCustomInput } from '../../../common/custom-hooks/useCustomInput';
import { ItipoConcepto } from '../../../system/projects/ProjectsSystem';
import { ClientConfigs, getAgrupadorItems, getDataRequiereConceptType } from '../../../lib/Util';
import { v4 as uuidv4 } from 'uuid';
import Project from '../../../system/projects/Project';
import useAsyncDataCourier from '../../../common/custom-hooks/useAsyncDataCourier';
import { User } from '../../../system/User';
import { TypeMessageEnhancement, useProjectEnhancement } from '../../../common/custom-hooks/useProjectEnhancement';
import { AiGradientIconFilled, AiGradientIconOutline } from '../../AiGradientIcon';
import SmartActionButton from '../../Common/SmartActionButton';
import FeedbackMessage from '../../FeedbackMessage';

interface IProjectConfigurationBasic {
  system: TimeTaxSupportSystemClient;
  courier: MessageCourier;
  organizationChartNodes: OrganizationChartNode[];
  collaboratorsList: Collaborator[];
  formProject: ProjectConfigurationForm;
  onBlurCustomInput: (customInput: CustomInputIfc) => void;
  onChangeBillable: (checked: boolean) => void;
  onChangeProjectTeam: (team: CollaboratorTeam[]) => void;
  selectedtipoConsep : ItipoConcepto;
  setSelectedtipoConsep : (data:ItipoConcepto)=>void;
  project?:Project;
  errortipoConcept : string;
  errorDescriptionProject: string;
  setErrorDescriptionProject: (data:string)=>void;
  setErrortipoConcept : (data:string)=>void;
  showDialogPreloadTeam: boolean;
  setShowDialogPreloadTeam: (show: boolean) => void;
  collaboratorsInSelectedNode: Collaborator[];
  setCollaboratorsInSelectedNode: (collaborators: Collaborator[]) => void;
  projectTeam: CollaboratorTeam[];
  user:User;
  setErrorAgrupador: (data:string)=>void;
  errorAgrupador: string;
  selectedAgrupador : IComboBoxOption;
  setSelectedAgrupador : (data:IComboBoxOption)=>void;
  configLiquidacionAgrupada: ClientConfigs | undefined;
}

export const ProjectConfigurationBasicData = (props: IProjectConfigurationBasic) => {
  const uuidTransaction:string = uuidv4();
  const [availableNodes, setAvailableNodes] = React.useState<OrganizationChartNode[]>([]);
  const [projectStatus, setProjectStatus] = React.useState<string>('');
  const [listTipoConsepto, setListTipoConsepto] = React.useState<ItipoConcepto[]>([]);
  const [showDescriptionError, setShowDescriptionError] = React.useState(false);
  const projectEnhancement = useProjectEnhancement(props.system.getAiProjectEnhancementSystem());

  const node = useAsyncDataCourier(
    () => {
      if (props.user) {
        return props.system
          .getOrganizationChartSystem()
          .getAvailableNodesOf(props.user);
      }
      return Promise.resolve([]);
    },
    [props.system, props.user],
    props.courier
  );

  const getvalue = ()=>{
    if(props.project && getDataRequiereConceptType()==="1"){
      props.setSelectedtipoConsep(props.project.getTipoConsep()!);
      props.setSelectedAgrupador(props.project.getAgrupador()!)
    }
  }

  const nodeInput = useCustomInput(() => {
    return props.formProject.getOrganizationNodeInput();
  }, [props.formProject]);

  const getlisTipoconcepto = async()=>{
    if(getDataRequiereConceptType()==="1" && listTipoConsepto.length === 0){
      const data = await props.system.getProjectSystem().gettipoConsepto(uuidTransaction);
      setListTipoConsepto(data);
    }
  }

  const hanndlerConseptTipe = (value)=>{
    props.setSelectedtipoConsep(value);
    if(value.key !== "0"){
      props.setErrortipoConcept("");
    }
  }

  const hanndlerAgrupador= (value)=>{
    props.setSelectedAgrupador(value);
    if(value.key !== "0"){
      props.setErrorAgrupador("");
    }
  }

  const hanndlerDescriptionProject = (value:string)=>{
    if(value.trim() !== ""){
      props.setErrorDescriptionProject("");
    }
  }

  React.useEffect(()=>{
    getvalue()
  },[props.project,listTipoConsepto]);

  React.useEffect(() => {
    getlisTipoconcepto();
    setProjectStatus(props.formProject.getStateInput().getValue());
  }, [props.formProject.getStateInput().getValue()]);


  React.useEffect(() => {
    setAvailableNodes([...props.organizationChartNodes]);
  }, [props.organizationChartNodes]);

  const onSelectNode = async (input: CustomInputIfc) => {
    if (
        props.formProject
            .getProjectTeamForm()
            .getInputProjectTeamItems()
            .getValue()
            .filter((item) => item.isActive()).length === 0
    ) {
      props.setShowDialogPreloadTeam(true);
    }
  };

  const getUnsavedProjectCode = () => {
    let ret = props.formProject.getBillableInput().getValue() ? 'FA' : 'NFA';
    if (props.formProject.getStartValue()) {
      ret += props.formProject.getStartValue().toFormat('yyyy');
    }
    return ret + '-X';
  };

  const preloadTeam = (confirm: boolean) => {
    if (confirm) {

{ /*     const elimnados = props.projectTeam.map((item)=>{
        props.collaboratorsInSelectedNode.forEach((i)=>{
         if(item.getCollaborator().getId() !== i.getId()) {
          item.set__delete(true)
        };
        });
        return item
      }); */}

      const colList = props.collaboratorsInSelectedNode;
      colList.forEach((col) => {
        const toAdd = CollaboratorTeam.initializeFromColaborador(col);

        props.formProject.getProjectTeamForm().getInputProjectTeamItems().add(toAdd);
      });

      props.onBlurCustomInput(props.formProject.getProjectTeamForm().getInputProjectTeamItems());
      const collaboratornew = props.formProject.getProjectTeamForm().getInputProjectTeamItems().getValue().filter((item) => item.isActive());
     // const fucion =  [ ...collaboratornew,...elimnados];
     const fucion =  [ ...collaboratornew];
      const uniqueObjects =fucion.filter((obj, index, self) =>
        index === self.findIndex((t) => t.getCollaborator().getId() === obj.getCollaborator().getId())
      );
      props.onChangeProjectTeam(uniqueObjects);
    }

    props.setShowDialogPreloadTeam(false);
  };

  const activateProject = async () => {
    await props.system.getProjectSystem().reactivate(props.formProject.getIdInput().getValue());
    setProjectStatus('En proceso');
    props.courier.messageSuccess(t('Proyecto activado exitosamente'));
  };

  const deactivateProject = async () => {
    await props.system.getProjectSystem().deactivate(props.formProject.getIdInput().getValue());
    setProjectStatus('Inactivo');
    props.courier.messageSuccess(t('Proyecto desactivado exitosamente'));
  };

  const finalizeProject = async () => {
    setProjectStatus('Finalizado');
    props.courier.messageSuccess(t('Proyecto finalizado exitosamente'));
  };

  const GlobalNavButtonIcon: IIconProps = { iconName: 'GlobalNavButton' };

  const contextualMenuItems = [
    {
      key: 'activate',
      text: t('Activate'),
      onClick: () => {
        activateProject();
      },
      iconProps: { iconName: 'ActivateOrders' },
      className: projectStatus === t('En proceso') ? 'hide-project-btn' : '',
    },
    {
      key: 'deactivate',
      text: t('Deactivate'),
      onClick: () => {
        deactivateProject();
      },
      iconProps: { iconName: 'DeactivateOrders' },
      className: projectStatus === t('Inactivo') ? 'hide-project-btn' : '',
    },
  /*   {
      key: 'finalize',
      text: t('Finalize'),
      onClick: () => {
        finalizeProject();
      },
      iconProps: { iconName: 'Completed' },
      className: projectStatus === t('Finalizado') ? 'hide-project-btn' : '',
    }, */
  ];

  const menuProps: IContextualMenuProps = {
    shouldFocusOnMount: true,
    items: contextualMenuItems,
  };

  const generateAI = () => {
    const project_name = props.formProject.getNameInput().getValue()  as string
    const project_description =props.formProject.getDescriptionInput().getValue()
    
    if (!project_name.trim()) return projectEnhancement.showMessage({ type: TypeMessageEnhancement.WARNING, className: 'warning-message-animate', value: '⚠️ El nombre de la actividad y nombre del proyecto es requerido' });
    
    projectEnhancement.generateEnhancement({ project_description, project_name }, (result) => {
      const descripcionInput = props.formProject.getDescriptionInput();
      const nombreInput = props.formProject.getNameInput()
      descripcionInput.setValue(result.project_description);
      nombreInput.setValue(result.project_name);
      nombreInput.onBlur();     
      setShowDescriptionError(false)
      props.courier.messageError('')
    })
  }

  

  const resetAI = () => {
    const original= projectEnhancement.resetToOriginal()
    
    const descripcionInput = props.formProject.getDescriptionInput();
    const nombreInput = props.formProject.getNameInput();
    descripcionInput.setValue(original.project_description);
    nombreInput.setValue(original.project_name);
    nombreInput.onBlur();     
    setShowDescriptionError(original.project_description.length === 0)
    props.courier.messageError('')
  }

  const disabledEnhancementButton = !projectEnhancement.wasGenerated && (projectEnhancement.loading || !(props.formProject.getNameInput().getValue() as string).trim())

  return (
      <div className="ms-Grid bg-white-h100 ms-depth-4" dir="ltr">
        <div className="ms-Grid-row padding-1">
          <div className="ms-Grid-col ms-sm12">
            <div className="ms-Grid-row ">
              <div className="ms-Grid-col ms-sm6 ">
                <Text variant={'large'} className={'project-config-section-title'}>
                  <Icon iconName="Teamwork" className="text-icon" />
                  {props.formProject.getCodeInput().getValue()
                      ?props.formProject.getCodeInput().getValue()
                      : props.selectedtipoConsep?.codigo +getUnsavedProjectCode()}
                </Text>
              </div>
              <div className="ms-Grid-col ms-sm6 ">
                {!props.formProject.isNew() && <ProjectStatus status={projectStatus} />}
                {!props.formProject.isNew() && (
                    <IconButton
                        className="float-right"
                        iconProps={GlobalNavButtonIcon}
                        title={t("Opciones de actividad")}
                        ariaLabel="GlobalNavButton"
                        menuProps={menuProps}
                    />
                )}
              </div>
            </div>
            {(getDataRequiereConceptType()==="1") &&
            <div className="ms-Grid-row mt-2">
              <div className="ms-Grid-col ms-sm4">
                < ComboBox
                  disabled={!props.formProject.isNew() }
                  options={listTipoConsepto}
                  label={t('Tipo de concepto (*)')}
                  onChange={ (_,values)=>hanndlerConseptTipe(values)}
                  text={props.selectedtipoConsep?.text}
                />
                { props.errortipoConcept !== "" && <span style={{color:"red"}}>{props.errortipoConcept}</span>}
              </div>
            </div>}

            {((getDataRequiereConceptType()==="1") && props.configLiquidacionAgrupada) &&
            <div className="ms-Grid-row mt-2">
              <div className="ms-Grid-col ms-sm4">
                <ComboBox
                  disabled={ props.configLiquidacionAgrupada.cltconf_action.toUpperCase() !== "W"}
                  /* disabled={!props.formProject.isNew() } */
                  options={getAgrupadorItems().map(a => ({ key: a.agrliqpro_id, text: a.agrliqpro_nombre}))}
                  label={t('Agrupador de liquidación')}
                  onChange={ (_,value)=> hanndlerAgrupador(value)}
                  text={props.selectedAgrupador?.text}
                />
                { props.errorAgrupador !== "" && <span style={{color:"red"}}>{t(props.errorAgrupador)}</span>}
              </div>
            </div>}
            <div className="ms-Grid-row mt-2">
              <div className="ms-Grid-col ms-sm6">
                <InputField
                    input={props.formProject.getNameInput()}
                    label={`${t('Nombre del proyecto')} ${getDataRequiereConceptType()==="1"? t('o servicio (*)'):''}`}
                    onBlur={props.onBlurCustomInput}
                    propsInput={{ className: projectEnhancement.wasGenerated ? 'input-focus-ai-generate' : '' }}
                />
              </div>
            </div>

            <div className="ms-Grid-row mt-2">
              <InputFieldForStartEnd
                  inputStart={props.formProject.getStartInput()}
                  inputEnd={props.formProject.getEndInput()}
                  startLabel={t("Vigencia - Inicio (*)")}
                  endLabel={t("Vigencia - Fin (*)")}
                  onBlur={props.onBlurCustomInput}
              />
            </div>
            <div className="ms-Grid-row mt-2">
{   node ?    <div className="ms-Grid-col ms-sm12 ">
                <OrganizationChartDropdown
                    // label={lastLevelNode ? lastLevelNode.getName() : ''}
                    label={t('Sector (*)')}
                    options={node}
                    autoComplete={'off'}
                    onChange={(node) => {
                      console.log(node)
                      const input = nodeInput;
                      input.setValue(node);
                      input.onBlur();
                      props.onBlurCustomInput(input);
                      onSelectNode(input);
                    }}
                    selectedKey={
                      props.formProject.getOrganizationNodeValue()
                          ? props.formProject.getOrganizationNodeValue()!.getId()
                          : undefined
                    }
                    hasError={props.formProject.getOrganizationNodeInput()}
              />
              </div>:null}
            </div>
            <div className="ms-Grid-row mt-2">
              <div className="ms-Grid-col ms-sm6">
                <ToggleInput
                    input={props.formProject.getBillableInput()}
                    onChangeExtended={(checked) => props.onChangeBillable(checked)}
                    onBlur={props.onBlurCustomInput}
                    offText={t('No facturable')}
                    onText={t('Facturable')}
                    propsInput={{ disabled: !props.formProject.isNew() }}
                />
              </div>

              <div className="ms-Grid-col ms-sm6">
                {/* <ToggleInput
                input={props.formProject.getSettlementInput()}
                onBlur={props.onBlurCustomInput}
                offText={'Liquidacion indirecta'}
                onText={'Liquidacion directa'}
                propsInput={{ disabled: !props.formProject.isNew(), styles: { container: { color: 'red' } } }}
              /> */}
              </div>
            </div>
            <div className="ms-Grid-row mt-2">
              <div className="ms-Grid-col ms-sm6">
                <ToggleInput
                    input={props.formProject.getConfidentialDocumentInput()}
                    onBlur={props.onBlurCustomInput}
                    offText={t('Documentos abiertos por defecto')}
                    onText={t('Documentos confidenciales por defecto')}
                />
              </div>
            </div>
            <div className="ms-Grid-row mt-2">
              <div className="ms-Grid-col ms-sm12">
                {projectEnhancement.message && (<FeedbackMessage message={projectEnhancement.message} close={projectEnhancement.clearMessage} style={{ width: 'auto' }} />)}

                <TextArea
                    input={props.formProject.getDescriptionInput()}
                    label={t("Descripción del proyecto (*)")}
                    onBlur={(descripcionInput: CustomInputIfc) => {
                      props.onBlurCustomInput(descripcionInput);
                      hanndlerDescriptionProject(descripcionInput.getValue());
                      const isEmpty = !descripcionInput.getValue() || !descripcionInput.getValue().trim();
                      setShowDescriptionError(isEmpty);
                      if (!isEmpty) {
                        props.courier.messageError('');
                      }
                    }}
                    propsInput={{ className: projectEnhancement.wasGenerated ? 'input-focus-ai-generate' : '' }}
                />
                { props.errorDescriptionProject !== "" && <span style={{color:"red"}}>{props.errorDescriptionProject}<br/></span>}
                <SmartActionButton
                    className='mt-2'
                    disabled={disabledEnhancementButton}
                    loading={projectEnhancement.loading}
                    onClick={projectEnhancement.wasGenerated ? resetAI : generateAI}
                    text={projectEnhancement.loading ? t("Mejorando...") : projectEnhancement.wasGenerated ? t("Deshacer") : t("Mejorar ")}
                    icon={projectEnhancement.wasGenerated ? <AiGradientIconOutline /> : <AiGradientIconFilled />}
                />
              </div>
            </div>
          </div>
          {props.formProject.getOrganizationEquipoValue() && (
              <ConfirmPreloadTeam
                  show={props.showDialogPreloadTeam}
                  collaborators={props.collaboratorsInSelectedNode.length}
                  onClose={preloadTeam}
                  nodeName={props.formProject.getOrganizationEquipoValue()!.getName()}
                  textTitle='Quieres incluir en el proyecto a todos los colaboradores que pertencen al area de'
              />
          )}
        </div>
      </div>
  );
};
